export class Pagination<PaginationObject> {
  items: PaginationObject[];
  meta: IPaginationMeta;
  stats?: IStats;
}

export interface IPaginationMeta {
  itemCount: number;
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

export interface IStats {
  totalSalesAmount?: number;
  completed?: number;
  failed?: number;
  cancelled?: number;
  notProcessed?: number;
  dataLoss?: number;
  active?: number;
  inactive?: number;
  totalCount?: number;
}
